module.exports = __webpack_public_path__ + "media/images/datepicker/cal-50d16a46821b6d5666aeba66f852b44e.gif";